import { ref } from "vue";
const modalStore = ref([]);
export function useModalStore() {
  function addInstance(id) {
    modalStore.value.push(id);
  }
  function removeInstance(id) {
    modalStore.value = modalStore.value.filter((x) => x !== id);
  }
  return {
    modalStore,
    addInstance,
    removeInstance
  };
}
